module.exports = __webpack_public_path__ + "static/media/west-live-hero.4ec207c7.jpg";